module.exports = __webpack_public_path__ + "img/IdrisAli.c97eae25.jpg";